import { useId, type SVGProps } from 'react';

const NoMemberFee = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect x="0.556" y="0.556" width="38.889" height="38.889" rx="8.333" fill="white" />
      <rect
        x="0.556"
        y="0.556"
        width="38.889"
        height="38.889"
        rx="8.333"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.111"
      />
      <path
        d="M22.896 27.411C20.602 27.411 18.855 25.336 18.855 21.794C18.855 18.253 20.602 16.178 22.896 16.178C25.205 16.178 26.937 18.253 26.937 21.794C26.937 25.336 25.205 27.411 22.896 27.411ZM22.896 26.709C24.768 26.709 26.203 24.93 26.203 21.794C26.203 18.658 24.768 16.88 22.896 16.88C21.039 16.88 19.588 18.658 19.588 21.794C19.588 24.93 21.039 26.709 22.896 26.709Z"
        fill="currentColor"
      />
      <path
        d="M14.328 9.835V19.29M16.396 11.253H13.294C12.91 11.253 12.541 11.427 12.27 11.738C11.998 12.048 11.846 12.469 11.846 12.908C11.846 13.347 11.998 13.768 12.27 14.078C12.541 14.388 12.91 14.563 13.294 14.563H15.362C15.746 14.563 16.114 14.737 16.386 15.047C16.657 15.357 16.81 15.778 16.81 16.217C16.81 16.656 16.657 17.077 16.386 17.387C16.114 17.698 15.746 17.872 15.362 17.872H11.846"
        stroke="currentColor"
        strokeWidth="0.709"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="40"
          y1="16.936"
          x2="0"
          y2="16.589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F59FF" />
          <stop offset="1" stopColor="#FF7749" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default NoMemberFee;
